// import { words } from "../content/copy";

export const wordStrategy = (words, blocks) => (
  contentBlock,
  callback,
  contentState
) => {
  if (!words.length) {
    return;
  }

  let text = contentBlock.getText();

  const finds = [];
  let offset = 0;

  const currentBlock = blocks.find((d) => d.key === contentBlock.getKey());
  const wordsInThisBlock = currentBlock
    ? words.filter((d) => {
        const { start, end } = currentBlock;
        return d.position[0] >= start && d.position[1] <= end;
      })
    : words;

  wordsInThisBlock
    .map((d) => d.term)
    .forEach((word) => {
      const regex = `(?:[^a-zA-Z]|^)(${word})(?:[^a-zA-Z]|$)`;
      // console.log("text", text);
      const rx = new RegExp(regex, "i");
      const match = rx.exec(text);

      if (match) {
        const start = match.index + match[0].indexOf(match[1]);
        const end = start + match[1].length;
        text = text.substring(end);
        finds.push({
          start: offset + start,
          end: offset + end,
          text: match[1],
        });
        offset = offset + end;
      }
    });

  finds.forEach(({ start, end }) => callback(start, end));

  // const remainingWords = words.slice(finds.length);
  // words = remainingWords;
  // console.log("remainingwords", finds.length, remainingWords);
};
